import { ready } from '@/lib/ready'
import { loadCarousel } from '@/share/carousel'

import '@/share/styles/components/promo-wizard.less'
import '@/share/styles/components/jcarousel.less'
import '@/share/styles/components/pagination.less'
import '@/share/styles/leftimagetag-fs.less'

import '@/share/styles/index.less'
import '@/share/global'
import '@/share/header'
import '@/share/footer'
import '@/share/product-show/product-box'
import '@/share/product-show/product-box-fs'
import '@/share/product-show/filter'
import '@/share/product-show/filter-quick-apply'
import '@/share/product-show/filter-mobile'
import '@/share/product-show/sortby'
import '@/share/review'

import './styles/index.less'

import { lazyLoad } from '@/lib/lazyLoad'

ready(() => {
  const carouselBanner = document.querySelector<HTMLElement>('#carouseltopbanner')
  if (carouselBanner) { //  && carouselBanner.querySelectorAll('li').length > 1
    loadCarousel(carouselBanner, {
      autoStart: true,
      interval: 5000,
      perPage: 1
    })
  }

  const jcarouselTestimonial = document.querySelector<HTMLElement>('#jcarousel-testimonial1')
  if (jcarouselTestimonial) {
    loadCarousel(jcarouselTestimonial, {
      autoStart: true,
      interval: 5000,
      perPage: 1,
      responsive: {
        0: 2,
        1000: 3,
        1200: 4
      }
    })
  }
})

// ready(() => {
//   on(
//     '.onsale-content',
//     'mouseover',
//     (e: MouseEvent) => {
//       const This = e.currentTarget as HTMLElement
//       ;(This.querySelectorAll('.moreSmall') as NodeListOf<HTMLElement>).forEach((item, index) => {
//         const imgName = item.dataset['path']
//         // var imgName = $(this).data('path');
//         // var hdImgPreUrl = This.find('.hdImgPreUrl').html();
//         const hdImgPreUrl = This.querySelector('.hdImgPreUrl')!.innerHTML
//         const name = This.querySelector('.zoom-tiny-image')?.getAttribute('title') ?? ''
//         // $(this).html('<input type="hidden" value="' + hdImgPreUrl + '/0220/' + imgName + '"><img class="zoom-tiny-image" src="' + hdImgPreUrl + '/0080/' + imgName + '" alt="' + name + '" title="' + name + '" />');

//         item.insertAdjacentHTML(
//           'afterbegin',
//           `<input type="hidden" value="${hdImgPreUrl}/0220/${imgName}"><img class="zoom-tiny-image" src="${hdImgPreUrl}/0080/${imgName}" alt="${name}" title="${name}" />`
//         )
//         removeClass(item, 'moreSmall')
//       })
//     },
//     onceOptions
//   )
// })
import('@/share/wish-list').then((r) => {
  r.wishList()
})

if (document.querySelector('.copy-link')) {
  import('@/share/copy-link')
}

// loadJq(() => {
//   let urlParma = window.siteConfig.webResourcePath + 'jscripts/2017/PromoWizardPageStyle2.js'

//   //@ts-ignore
//   if (typeof window.IsNeedLoadMoreFunction != 'undefined') {
//     urlParma = window.siteConfig.webResourcePath + 'jscripts/2017/PromoWizardLoadMoreStyle.js'
//   }
// })

ready(() => {
  // // @ts-ignore
  // import('@/share/couponbar')

  const tooltipElements = document.querySelectorAll<HTMLElement>('.a_glossary')
  import('@/lib/tooltip').then((f) => {
    f.aptip(tooltipElements)
  })
})

//promotionPopup
ready(() => {
  import('@/share/promotionPopup').then((f) => {
    f.loadPromotionPopup()
  })
})

ready(() => {
  lazyLoad('.best-sellers__banner .item-0 embed', (item) => {
    const src = item.getAttribute('src')
    if (!src) {
      item.setAttribute('src', (item.nextElementSibling as HTMLInputElement).value)
    }
  })
  lazyLoad('.best-sellers__banner .item-0 img', (item) => {
    const src = item.getAttribute('src')
    if (!src) {
      item.setAttribute('src', item.getAttribute('data-original') as string)
    }
  })
})
const setIframeSize = (pixels: any) => {
  $('#IframeSuperRush').height(pixels)
}
Object.assign(window, { setIframeSize })
